// src/components/Home.js
import React, { useState } from 'react';
import { Box, Typography, Button, Container } from '@mui/material';
import { motion } from 'framer-motion';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import GitHubIcon from '@mui/icons-material/GitHub';
import PhotoLibraryOutlinedIcon from '@mui/icons-material/PhotoLibraryOutlined';
import SlideShow from './SlideShow';
import MyGallery from './MyGallery';
import EntryAnimation from './EntryAnimation';

function Home() {
  const slideImages = [
    `${process.env.PUBLIC_URL}/images/slide1.jpg`,
    `${process.env.PUBLIC_URL}/images/slide2.jpg`,
    `${process.env.PUBLIC_URL}/images/slide3.jpg`,
    `${process.env.PUBLIC_URL}/images/slide4.jpg`,
  ];

  const [openGallery, setOpenGallery] = useState(false);
  const handleOpenGallery = () => setOpenGallery(true);
  const handleCloseGallery = () => setOpenGallery(false);

  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (!section) return;

    const headerOffset = 80;
    const elementPosition = section.getBoundingClientRect().top;
    window.scrollTo({
      top: elementPosition + window.pageYOffset - headerOffset,
      behavior: 'smooth'
    });
  };

  return (
    <Box
      id="home"
      sx={{
        position: 'relative',
        width: '100vw',
        minHeight: { xs: 'calc(100svh - 80px)', md: 'calc(100vh - 80px)' },
        py: { xs: 5, md: 4 },
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
      }}
    >
      {/* Background Slideshow with overlay */}
      <Box sx={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 0 }}>
        <SlideShow images={slideImages} intervalTime={5000} />
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background: 'linear-gradient(to right, rgba(10, 25, 41, 0.9) 0%, rgba(10, 25, 41, 0.6) 50%, rgba(10, 25, 41, 0.3) 100%)',
          }}
        />
      </Box>

      <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 2 }}>
        <motion.div
          initial={{ opacity: 1, x: 0 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 1, ease: 'easeOut' }}
        >
          <EntryAnimation />

            <Typography
              variant="h1"
              sx={{
                color: 'white',
                fontSize: { xs: '2.25rem', md: '3.5rem' },
                fontWeight: 900,
                lineHeight: 1.1,
                mb: 1,
              }}
            >
              Hi, I'm <br />
              <Box component="span" sx={{
                background: 'linear-gradient(45deg, #00e5ff 30%, #7c4dff 90%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
              }}>
                Okada Takeo
              </Box>
            </Typography>

            <Typography
              variant="h6"
              sx={{
                color: 'primary.main',
                maxWidth: '720px',
                mt: 2,
                mb: 1,
                lineHeight: 1.6,
                fontWeight: 700
              }}
            >
              VLM × 外観検査を研究中
            </Typography>

            <Typography sx={{ color: 'text.secondary', mb: 3, fontSize: { xs: '0.95rem', md: '1.05rem' } }}>
              岐阜大学大学院 自然科学技術研究科｜修士課程
            </Typography>

          <Box sx={{ display: 'flex', gap: 1.5, flexWrap: 'wrap' }}>
            <Button
              variant="contained"
              size="large"
              onClick={() => scrollToSection('projects')}
              endIcon={<ArrowForwardIcon />}
            >
              Projects
            </Button>
            <Button
              variant="outlined"
              size="large"
              onClick={() => scrollToSection('publications')}
              startIcon={<ArticleOutlinedIcon />}
              sx={{ color: 'white', borderColor: 'rgba(255,255,255,0.3)' }}
            >
              Publications
            </Button>
            <Button
              variant="text"
              size="large"
              href="https://github.com/otake-code"
              target="_blank"
              rel="noopener noreferrer"
              startIcon={<GitHubIcon />}
              sx={{ color: 'white' }}
            >
              GitHub
            </Button>
            <Button
              size="large"
              onClick={handleOpenGallery}
              startIcon={<PhotoLibraryOutlinedIcon />}
              sx={{ color: 'text.secondary' }}
            >
              Gallery
            </Button>
          </Box>
        </motion.div>
      </Container>


      {openGallery && (
        <MyGallery images={slideImages} onClose={handleCloseGallery} />
      )}
    </Box>
  );
}

export default Home;
